export class Hauler {
    active: number
    mailingAddress: string
    username: string
    countRating?: number
    msaId: string
    companyId?: string
    type: number | string
    avatar?: string
    starRating: number
    firstName: string
    lastName: string
    rating: number
    numberCompliments: number
}



// WEBPACK FOOTER //
// ./src/types/Hauler.ts